import { MULTI_SELECT_TABLE_VIEW_VALUE_TAG_CLASS } from '@constants/table.ts';
import { BODY_XS_XS_MEDIUM_STYLES } from '@constants/text.ts';
import { Tag as AntTag } from 'antd';
import styled from 'styled-components';

export const Tag = styled(AntTag)`
    margin-bottom: 8px;

    &.${MULTI_SELECT_TABLE_VIEW_VALUE_TAG_CLASS} {
        color: var(--colors-text-body, #50566e);
        ${BODY_XS_XS_MEDIUM_STYLES};
        border-radius: var(--border-radius-xs_4, 4px);
        border: var(--border-width-sm_1, 1px) solid var(--colors-border-default, #b4b8bf);
        background: var(--colors-surface-primary, #fff);
        margin-bottom: 2px;
        margin-right: 4px;
    }
`;
